/**
 * Временные ограничения запуска.
 * PAYMENTS_ENABLED включается после подключения эквайринга.
 */
export const PAYMENTS_ENABLED = import.meta.env.VITE_PAYMENTS_ENABLED === 'true';
